import React, { useState } from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import Moment from "moment";
import { extendMoment } from "moment-range";
import { useIntl } from "react-intl";
import CalendarWrapper from "./Calendar.style";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {
  getActiveOrders,
  isSchedulingAllowedOverlapping,
  isLoadingHours,
} from "../../../components/util/helpers";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
const DragAndDropCalendar = withDragAndDrop(Calendar);
const moment = extendMoment(Moment);
const localizer = momentLocalizer(moment);

var tinycolor = require("tinycolor2");

const CalendarComponent = (props) => {
  const {
    currentDate,
    onNavigate,
    calenderView,
    events,
    ordersBorderPalette,
    ordersBgPalette,
    changeEvent,
    editEvent,
    viewEvent,
    createEvent,
    goToDayView,
    loading,
    filteredOrders,
    customEvent,
    orders,
    activePatient,
    holidays,
    effective_orders,
  } = props;
  const localeLang = "he";
  const displayDragItemInCell = true;
  const [draggedEvent, setDraggedEvent] = useState(null);
  const { absences = [] } = activePatient;
  const { hospitalizations = [] } = activePatient;

  const [modal, contextHolder] = Modal.useModal();
  var startOfMonth = moment().startOf("month").toDate();
  const onView = (val) => {};
  const intl = useIntl();
  const isAbsenceDay = (date) => {
    let isWithinAbsences = false;
    for (let i = 0; i < absences.length; i++) {
      const range = moment.range(
        absences[i].effective_from,
        absences[i].effective_to || moment(currentDate).endOf("month").format()
      );

      const isAbsenceDate = moment(date).within(range);

      if (isAbsenceDate) {
        isWithinAbsences = true;
      }
    }
    return isWithinAbsences;
  };

  const dayPropGetter = (date) => {
    const noSchedulingView =
      (calenderView === Views.WEEK &&
        !moment(moment(date)).isSame(moment(currentDate), "month")) ||
      isAbsenceDay(date);
    return (
      noSchedulingView && {
        style: {
          backgroundColor: "#e6e6e6",
          borderColor: "#e6e6e6",
        },
      }
    );
  };

  const eventStyleGetter = (event, start, end, isSelected) => {
    const order = orders
      ? orders.filter((i) => i.id === event.order_id)[0]
      : null;
    const startsInCurrentMonth =
      order &&
      order.effective_from &&
      moment(order.effective_from) >= moment().startOf("month");
    const endsInCurrentMonth =
      order &&
      order.effective_to &&
      moment(order.effective_to) <= moment().endOf("month");
    const categoryName =
      order && order["client"] ? order["client"]["category"].name : "";
    let bgColor = categoryName
      ? ordersBgPalette[categoryName] || "#FBEEF1"
      : event.holiday
      ? "#19ADF8"
      : event.hospitalization_day
      ? "#e6e6e6"
      : "black";
    let borderColor = categoryName
      ? ordersBorderPalette[categoryName] || "#D7C2C8"
      : event.holiday
      ? "#19ADF8"
      : event.hospitalization_day
      ? "#e6e6e6"
      : "black";
    if (startsInCurrentMonth && endsInCurrentMonth) {
      bgColor = tinycolor(bgColor).darken(15).desaturate(10).toHexString(); // "#f53d3d"
      borderColor = tinycolor(borderColor)
        .darken(15)
        .desaturate(10)
        .toHexString(); // "#f53d3d"
    } else if (endsInCurrentMonth) {
      bgColor = tinycolor(bgColor).darken(30).desaturate(10).toHexString(); // "#f53d3d"
      borderColor = tinycolor(borderColor)
        .darken(30)
        .desaturate(10)
        .toHexString(); // "#f53d3d"
    }
    var style = {
      backgroundColor: event.hospitalization_day ? "transparent" : bgColor,
      opacity: categoryName
        ? 1
        : event.holiday
        ? 1
        : event.hospitalization_day
        ? 1
        : 0.4,
      borderColor: event.recurrent_id ? borderColor : "#000000",
      borderStyle: event.recurrent_id ? "solid" : "dashed",
      borderWidth: event.holiday
        ? "0px"
        : event.hospitalization_day
        ? "0px"
        : event.recurrent_id
        ? "1px"
        : "3px",
    };
    return {
      style: style,
    };
  };

  const handleDragStart = (event) => {
    setDraggedEvent(event);
  };

  const dragFromOutsideItem = () => {
    return draggedEvent;
  };

  const checkForOverloading = (event, start, end) => {
    const loadingHours = isLoadingHours(events, event, start, end);
    if (loadingHours) {
      const title = intl.formatMessage({
        id: "app.scheduling.overlappingMonthViewTitle",
      });
      const content = intl.formatMessage({
        id: "app.scheduling.overlappingMonthViewDescription",
      });
      return modal.confirm({
        title: title,
        icon: <ExclamationCircleOutlined />,
        content: content,
        okText: intl.formatMessage({
          id: "app.actions.changeEvent",
        }),
        cancelText: intl.formatMessage({
          id: "app.actions.continue",
        }),
        onOk() {
          return editEvent({ ...event, start, end });
        },
        onCancel() {
          return shouldChangeEvent(event, start, end);
        },
      });
    } else {
      shouldChangeEvent(event, start, end);
    }
  };

  const shouldChangeEvent = (event, start, end) => {
    // Check if duration is less than 15 minutes
    const durationMinutes = moment(end).diff(moment(start), "minutes");
    if (durationMinutes < 15) {
      return;
    }
    const differentMonth = isOtherMonth(start);
    const isAllowedOverlapping = isSchedulingAllowedOverlapping(
      events,
      event,
      start,
      end
    );

    const loadingHours = isLoadingHours(events, event, start, end);
    if (loadingHours && isAllowedOverlapping) {
      const title = intl.formatMessage({
        id: "app.scheduling.overlappingEventsModalTitle",
      });
      const content = intl.formatMessage({
        id: "app.scheduling.overlappingEventsModalDescription",
      });
      modal.confirm({
        title: title,
        icon: <ExclamationCircleOutlined />,
        content: content,
        onOk() {
          return changeEvent(event, start, end);
        },
        onCancel() {},
      });
    } else if (
      !event.holiday &&
      !event.hospitalization_day &&
      !event.prospectus_id &&
      !event.nonAvailable &&
      !differentMonth &&
      !event.is_day_center &&
      isAllowedOverlapping
    ) {
      changeEvent(event, start, end);
    }
  };

  const moveEvent = ({ event, start, end }) => {
    if (moment(end) > moment(start).endOf("day")) {
      end = moment(start).endOf("day").toDate();
    }
    if (calenderView === Views.MONTH) {
      checkForOverloading(event, start, end);
    } else {
      shouldChangeEvent(event, start, end);
    }
  };

  const resizeEvent = ({ event, start, end }) => {
    shouldChangeEvent(event, start, end);
    // if (!event.holiday && !event.prospectus_id && !event.nonAvailable) {
    //   changeEvent(event, start, end);
    // }
  };

  const onSelectSlot = (event) => {
    const differentMonth = isOtherMonth(event.start);
    if (calenderView === Views.MONTH) {
      if (event.action === "doubleClick") {
        goToDayView(event);
      }
    } else if (!differentMonth && !isAbsenceDay(event.start)) {
      createEvent(event);
    }
  };

  const onDoubleClickEvent = (event) => {
    if (
      !event.holiday &&
      !event.hospitalization_day &&
      !event.prospectus_id &&
      !event.nonAvailable &&
      !event?.ok2go_info?.id &&
      !event.is_day_center
    ) {
      editEvent(event);
    } else if (event.prospectus_id || event?.ok2go_info?.id) {
      viewEvent(event);
    }
  };

  const isOtherMonth = (date) => {
    const differentMonth =
      calenderView === Views.WEEK &&
      !moment(moment(date)).isSame(moment(currentDate), "month");
    return differentMonth;
  };

  const getNonAvailabaleDays = (weekDay) => {
    var dayInWeek = moment(currentDate).startOf("month").day(weekDay);
    let arr = [];
    if (dayInWeek.date() > 7) dayInWeek.add(7, "d");
    var month = dayInWeek.month();
    while (month === dayInWeek.month()) {
      arr.push(dayInWeek.format());
      dayInWeek.add(7, "d");
    }
    return arr;
  };

  let tableEvents = [];
  events.forEach((item, i) => {
    var isFiltered = filteredOrders.includes(item.order_id);
    if (!isFiltered) {
      const order = effective_orders.find(
        (order) => order.id === item.order_id
      );
      if (order) {
        item.order = order;
      }
      tableEvents.push(item);
    }
  });

  holidays.forEach((item, i) => {
    tableEvents.push({
      title: item.name,
      start: moment(item.date).startOf("day").toDate(),
      end: moment(item.date).endOf("day").toDate(),
      date: item.date,
      holiday: true,
      id: 10000 + i,
    });
  });
  hospitalizations.forEach((item, index) => {
    let currentDay = moment(item.effective_from);
    const endDay = item.effective_to
      ? moment(item.effective_to)
      : moment(currentDate).endOf("month");

    while (currentDay <= endDay) {
      let start = currentDay.clone().startOf("day").toDate();
      let end = currentDay.clone().endOf("day").toDate();

      tableEvents.push({
        start,
        end,
        date: currentDay.clone().toDate(),
        hospitalization_day: true,
        id: 200000000 + tableEvents.length,
      });

      currentDay.add(1, "days");
    }
  });

  if (
    activePatient.non_available_hours &&
    activePatient.non_available_hours.length > 0
  ) {
    activePatient.non_available_hours.forEach((item, i) => {
      const days = getNonAvailabaleDays(item.day_of_week);
      days.forEach((day, i) => {
        const startDate = moment(day).set("minute", item.start_time_minutes);
        const nonAvailableStart = startDate.toDate();
        const nonAvailableEnd = startDate
          .add(item.duration_minutes, "minutes")
          .toDate();
        tableEvents.push({
          start: nonAvailableStart,
          end: nonAvailableEnd,
          nonAvailable: true,
          id: 20000 + i,
        });
      });
    });
  }

  const activeOrders = getActiveOrders(currentDate, orders);
  return (
    <CalendarWrapper>
      {contextHolder}
      <DragAndDropCalendar
        popup
        view={calenderView}
        onView={onView}
        date={moment(currentDate).toDate()}
        rtl={localeLang === "he"}
        onNavigate={onNavigate}
        selectable
        step={15}
        draggableAccessor={(event) =>
          // calenderView !== Views.MONTH &&
          !loading && !event.approved && !event?.ok2go_info?.id
        }
        localizer={localizer}
        events={tableEvents}
        resizable
        defaultView={Views.MONTH}
        defaultDate={startOfMonth}
        style={{ height: "100%" }}
        drilldownView={Views.DAY}
        toolbar={false}
        eventPropGetter={eventStyleGetter}
        dayPropGetter={dayPropGetter}
        onEventDrop={moveEvent}
        onEventResize={resizeEvent}
        onDoubleClickEvent={onDoubleClickEvent}
        dragFromOutsideItem={displayDragItemInCell ? dragFromOutsideItem : null}
        handleDragStart={handleDragStart}
        showMultiDayTimes
        scrollToTime={new Date(1970, 1, 1, 8)}
        components={{
          event: customEvent,
        }}
        tooltipAccessor={null}
        onSelectSlot={
          activeOrders.length === 0 && calenderView === Views.DAY
            ? null
            : onSelectSlot
        }
      />
    </CalendarWrapper>
  );
};

export default CalendarComponent;
